// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"Carousel_carouselContainer__2GSme","mainCarousel":"Carousel_mainCarousel__2KpE1","mainCarouselItem":"Carousel_mainCarouselItem__3kIlg"};